{
  "module-title": "Divulgación de Cierre",
  "page-heading": "Tu Divulgación de Cierre",

  "role-buyer": "Comprador",
  "role-seller": "Vendedor",
  "role-lender": "Prestamista",
  "role-title-company": "Compañía de Título",
  "role-agent": "Agente de Bienes Raíces",
  "role-listing-agent": "Agente Listador",
  "role-selling-agent": "Agente Vendedor",

  "overview-section": "Resumen de la Transacción",
  "overview-purchase-price": "Precio de Compra",
  "overview-loan-amount": "Monto del Préstamo",
  "overview-down-payment": "Pago Inicial",
  "overview-closing-date": "Fecha de Cierre",
  "overview-property-address": "Dirección de la Propiedad",
  "overview-loan-estimate": "Estimación del Préstamo",

  "buyer-cash-header": "Efectivo que Necesitas al Cierre",
  "buyer-cash-description": "Este es el monto total de dinero que debes traer al cierre. Incluye tu pago inicial, costos de cierre no pagados por el vendedor, y otros ajustes adeudados al firmar.",
  "buyer-cash-breakdown": "Desglose de Efectivo",
  "buyer-total-due": "Total Adeudado por el Comprador",

  "seller-proceeds-header": "Tus Ganancias de la Venta",
  "seller-proceeds-description": "Este es el monto neto de dinero que recibirás después de que se resten todos los costos, comisiones y pagos del precio de venta. Representa tu participación accionaria en la casa.",
  "seller-proceeds-breakdown": "Desglose de Ganancias",
  "seller-total-due": "Ganancias Totales del Vendedor",

  "lender-summary": "Información del Prestamista",
  "lender-name": "Nombre del Prestamista",
  "lender-loan-number": "Número de Préstamo",
  "lender-loan-type": "Tipo de Préstamo",
  "lender-interest-rate": "Tasa de Interés",
  "lender-monthly-payment": "Pago Mensual Estimado",

  "property-section": "Información de la Propiedad",
  "property-map": "Ubicación de la Propiedad",
  "property-parcel-number": "Número de Lote",
  "property-legal-description": "Descripción Legal",

  "charges-section": "Desglose de Costos de Cierre",
  "charges-expand-detail": "Mostrar Detalles",
  "charges-collapse-detail": "Ocultar Detalles",
  "charges-total": "Costos Totales de Cierre",

  "title-insurance-section": "Seguro de Protección de Propiedad",
  "title-insurance-title": "Seguro de Protección de Propiedad",
  "title-insurance-what-is": "Este es un seguro que te protege a ti y al prestamista contra problemas con la propiedad del inmueble. Si alguien posteriormente reclama derechos sobre tu propiedad o se descubren gravámenes o reclamaciones contra ella, este seguro cubre tus costos legales y cualquier pérdida financiera. Es una prima única pagada al cierre que te protege mientras seas propietario de la propiedad.",
  "title-insurance-who-pays": "Típicamente el vendedor paga por la póliza del propietario y la póliza del prestamista al cierre",
  "title-insurance-when": "La prima se paga al cierre",
  "title-insurance-why": "Tu prestamista requiere este seguro para proteger su inversión. También puedes obtener una póliza del propietario para protegerte contra problemas de título que podrían no estar cubiertos por la póliza del prestamista.",
  "title-insurance-lenders-policy": "Póliza del Prestamista",
  "title-insurance-lenders-policy-detail": "Protege solo la inversión del prestamista. Cuesta aproximadamente 0.5-1% del monto del préstamo. Vence cuando se paga el préstamo.",
  "title-insurance-owners-policy": "Póliza del Propietario",
  "title-insurance-owners-policy-detail": "Protege tu participación accionaria. Se recomienda aunque es opcional. Cuesta similar a la póliza del prestamista. Te protege indefinidamente.",

  "escrow-section": "Información de la Cuenta de Depósito en Garantía",
  "escrow-header": "Cuenta de Depósito en Garantía",
  "escrow-what-is": "Una cuenta de depósito en garantía es una cuenta especial mantenida en confianza donde recolectamos dinero cada mes para pagar tu seguro de propietario y impuestos sobre la propiedad. Cada mes, una porción de tu pago de hipoteca se deposita en esta cuenta. Cuando vencen tu seguro e impuestos, los pagamos desde esta cuenta. Esto te protege asegurando que estos pagos críticos no se pierdan, y protege al prestamista asegurando que la propiedad siempre esté asegurada y los impuestos estén al corriente.",
  "escrow-who-manages": "Tu prestamista gestiona esta cuenta",
  "escrow-when": "Los depósitos comienzan al cierre",
  "escrow-why": "Tu prestamista requiere esto para asegurar que tus impuestos sobre la propiedad y seguro siempre se mantengan pagados. Si estos pagos se perdieran, podría poner la propiedad en riesgo de ejecución hipotecaria o pérdida de cobertura de seguro.",
  "escrow-insurance-breakdown": "Depósito de Seguro",
  "escrow-insurance-amount": "Depósito de seguro inicial",
  "escrow-insurance-explanation": "Estamos recolectando un pago inicial de aproximadamente dos a tres meses de primas de seguro de propietario para iniciar tu cuenta de depósito en garantía",
  "escrow-taxes-breakdown": "Depósito de Impuesto sobre la Propiedad",
  "escrow-taxes-amount": "Depósito de impuesto sobre la propiedad inicial",
  "escrow-taxes-explanation": "Estamos recolectando un pago inicial para cubrir impuestos sobre la propiedad hasta el próximo pago adeudado. Este monto varía según tus tasas locales de impuestos sobre la propiedad y el cronograma de pagos de tu condado",
  "escrow-monthly-breakdown": "Desglose de Depósito en Garantía Mensual",
  "escrow-monthly-insurance": "Porción de pago de seguro mensual",
  "escrow-monthly-taxes": "Porción de impuesto sobre la propiedad mensual",
  "escrow-monthly-total": "Pago total de depósito en garantía mensual",

  "recording-section": "Costos de Grabación Gubernamental",
  "recording-title": "Costos de Grabación Gubernamental",
  "recording-what-is": "Cuando compras una propiedad, varios documentos legales (escritura, hipoteca y otros acuerdos) deben ser presentados ante el gobierno del condado. Estos costos pagan por ese proceso de presentación y grabación oficial. La oficina del grabador mantiene estos documentos como registro público.",
  "recording-who-pays": "Típicamente el comprador y vendedor cada uno pagan sus propios costos de grabación, aunque esto puede variar según el estado",
  "recording-when": "Se pagan al cierre",
  "recording-why": "La grabación protege tus derechos de propiedad al crear un registro público oficial. También asegura que la hipoteca del prestamista esté grabada adecuadamente y tenga prioridad si hay reclamaciones en competencia.",
  "recording-deed": "Grabación de Escritura",
  "recording-deed-detail": "Costo para grabar la escritura (tu documento de transferencia de propiedad)",
  "recording-mortgage": "Grabación de Hipoteca",
  "recording-mortgage-detail": "Costo para grabar la hipoteca o escritura de confianza (el interés del prestamista en la propiedad)",
  "recording-other": "Otros Costos de Grabación",
  "recording-other-detail": "Costos por grabar otros documentos como afidávits, levantamientos topográficos o liberaciones de gravámenes",

  "appraisal-section": "Valuación de Propiedad",
  "appraisal-title": "Tarifa de Valuación de Propiedad",
  "appraisal-what-is": "El prestamista requiere una valuación profesional para confirmar que la propiedad vale la cantidad que se está pidiendo prestada. Un tasador es un profesional independiente que inspecciona la propiedad y la compara con propiedades similares que se han vendido recientemente en el área. Esto protege al prestamista asegurando que no está prestando más de lo que la propiedad vale.",
  "appraisal-who-pays": "El comprador típicamente paga (a menudo pagado durante la pre-aprobación o pre-cierre)",
  "appraisal-when": "Generalmente se completa antes del cierre",
  "appraisal-why": "Si la propiedad se valúa a un precio menor que el precio de compra, afecta el monto del préstamo y tu pago inicial",
  "appraisal-report": "Informe de Valuación",
  "appraisal-report-detail": "Evaluación profesional detallada del valor de la propiedad basada en la condición, ubicación y ventas comparables",

  "inspection-section": "Inspección del Hogar",
  "inspection-title": "Tarifa de Inspección del Hogar",
  "inspection-what-is": "Un inspector del hogar examina la condición de la casa e identifica cualquier problema existente con la estructura, sistemas o componentes principales como el techo, cimiento, tuberías, electricidad, calefacción y aire acondicionado. Esta inspección te da una visión detallada de la condición de la casa antes de que estés comprometido a comprarla.",
  "inspection-who-pays": "El comprador típicamente paga",
  "inspection-when": "Típicamente se realiza antes del cierre (durante el período de inspección especificado en la oferta)",
  "inspection-why": "Esto te ayuda a tomar una decisión informada sobre la propiedad y negociar reparaciones o créditos si se descubren problemas importantes",
  "inspection-report": "Informe de Inspección",
  "inspection-report-detail": "Informe escrito detallado de los hallazgos, condiciones y recomendaciones del inspector",

  "survey-section": "Verificación de Límites de Propiedad",
  "survey-title": "Verificación de Límites de Propiedad",
  "survey-what-is": "Un topógrafo es un profesional licenciado que determina los límites exactos y el tamaño de tu propiedad utilizando descripciones legales, registros de propiedad y mediciones en el sitio. Crea un mapa topográfico oficial que muestra dónde cae tu línea de propiedad y dónde se ubican mejoras como edificios, caminos de entrada y cercas.",
  "survey-who-pays": "Vendedor o comprador (términos establecidos en el acuerdo de compra)",
  "survey-when": "Generalmente se completa antes del cierre si es requerido",
  "survey-why": "Un levantamiento topográfico previene disputas de límites, confirma que las mejoras se encuentren dentro de tu línea de propiedad, y es requerido por muchos prestamistas",
  "survey-update": "Levantamiento Topográfico Actualizado",
  "survey-update-detail": "El topógrafo confirma los límites y ubica estructuras en la propiedad",

  "origination-section": "Originación del Préstamo",
  "origination-title": "Tarifa de Originación del Préstamo",
  "origination-what-is": "Esta tarifa cubre los costos del prestamista para procesar, verificar y aprobar tu solicitud de préstamo. Incluye costos de revisar tu información financiera, obtener reportes de crédito, verificar empleo y activos, y coordinar con suscriptores.",
  "origination-who-pays": "El comprador típicamente paga (puede ser negociado)",
  "origination-when": "Se paga al cierre",
  "origination-why": "Los prestamistas cobran esta tarifa para cubrir sus costos administrativos y de suscripción. Típicamente se expresa como un porcentaje del monto del préstamo (por ejemplo, 0.5% a 1.5%).",
  "origination-percentage": "Tarifa de Originación (%)",
  "origination-percentage-detail": "Porcentaje del monto del préstamo cobrado como tarifa de originación",

  "points-section": "Puntos del Préstamo",
  "points-title": "Puntos del Préstamo (Puntos de Descuento)",
  "points-what-is": "Los puntos son una forma opcional de reducir tu tasa de interés. Un punto equivale al 1% del monto del préstamo. Al pagar puntos al cierre, permanentemente reduces tu tasa de interés, lo que reduce tu pago hipotecario mensual. Este es un intercambio: pagas más efectivo al cierre para ahorrar dinero en los pagos a lo largo del tiempo.",
  "points-who-pays": "El comprador paga si elige hacerlo (a veces negociado con el vendedor)",
  "points-when": "Se pagan al cierre (opcional)",
  "points-why": "Los puntos tienen sentido si planeas quedarte en la casa el tiempo suficiente para recuperar el costo inicial a través de pagos mensuales más bajos. Generalmente, cada punto pagado reduce la tasa de interés aproximadamente el 0.25%.",
  "points-discount": "Puntos de Descuento",
  "points-discount-detail": "Interés prepagado opcional para reducir tu tasa de interés del préstamo",
  "points-break-even": "El punto de equilibrio en los puntos típicamente ocurre después de 5-7 años",

  "lender-credits-section": "Créditos del Prestamista",
  "lender-credits-title": "Créditos del Prestamista (Ayuda del Prestamista)",
  "lender-credits-what-is": "Estos son créditos o concesiones del prestamista para ayudar a pagar algunos de tus costos de cierre. El prestamista ofrece esto a cambio de que aceptes una tasa de interés más alta. Es una forma en que el prestamista te ayuda a compensar tus costos de cierre de bolsillo.",
  "lender-credits-who-pays": "El prestamista proporciona este crédito",
  "lender-credits-when": "Se aplica al cierre",
  "lender-credits-why": "Esta opción ayuda a los prestatarios que necesitan ayuda con los costos de cierre pero están dispuestos a aceptar una tasa de interés ligeramente más alta a cambio",
  "lender-allowance": "Asignación del Prestamista",
  "lender-allowance-detail": "Crédito del prestamista aplicado hacia tus costos de cierre",

  "processing-section": "Procesamiento del Préstamo",
  "processing-title": "Tarifa de Procesamiento del Préstamo",
  "processing-what-is": "Esta tarifa cubre el costo de procesar tu solicitud de préstamo. Esto incluye revisar documentos, ordenar valuaciones, obtener crédito, coordinar la suscripción y preparar documentos de cierre.",
  "processing-who-pays": "El comprador típicamente paga",
  "processing-when": "Se paga al cierre",

  "underwriting-section": "Suscripción del Préstamo",
  "underwriting-title": "Tarifa de Suscripción del Préstamo",
  "underwriting-what-is": "Esta tarifa cubre la revisión del suscriptor de tu archivo de préstamo completo para asegurar que cumple con los estándares del prestamista y los requisitos del inversionista. El suscriptor verifica toda tu información financiera y asegura que la propiedad cumpla con los criterios de préstamo.",
  "underwriting-who-pays": "El comprador típicamente paga",
  "underwriting-when": "Se paga al cierre",

  "credit-section": "Informe de Crédito",
  "credit-title": "Tarifa de Informe de Crédito",
  "credit-what-is": "El prestamista necesita obtener tu informe de crédito para evaluar tu solvencia. Esta tarifa cubre el costo de obtener y revisar tu historial de crédito de las principales agencias de crédito.",
  "credit-who-pays": "El comprador típicamente paga",
  "credit-when": "Se paga al cierre",

  "commissions-section": "Comisiones de Bienes Raíces",
  "commissions-title": "Comisiones de Bienes Raíces",
  "commissions-what-is": "Los agentes de bienes raíces ayudan a vender propiedades y muestran propiedades a los compradores. Ganan una comisión como porcentaje del precio de venta, típicamente dividida entre el agente listador (agente del vendedor) y el agente vendedor (agente del comprador). Las comisiones son típicamente 5-6% del precio de venta.",
  "commissions-who-pays": "El vendedor típicamente paga de las ganancias de la venta",
  "commissions-when": "Se pagan al cierre de las ganancias del vendedor",
  "commissions-why": "Los agentes proporcionan servicios valiosos incluyendo comercialización de la propiedad, mostrar a posibles compradores, negociar ofertas y coordinar el proceso de cierre",
  "commissions-selling": "Comisión del Agente Vendedor",
  "commissions-selling-detail": "Comisión pagada al agente del comprador",
  "commissions-listing": "Comisión del Agente Listador",
  "commissions-listing-detail": "Comisión pagada al agente del vendedor",

  "earnest-section": "Depósito de Buena Fe",
  "earnest-title": "Depósito de Buena Fe",
  "earnest-what-is": "Cuando hiciste una oferta para comprar la propiedad, depositaste dinero de buena fe para mostrar que estabas serio en tu compra. Este dinero se mantiene en una cuenta de confianza por la compañía de título o agente de depósito en garantía. Al cierre, este dinero de buena fe se aplica hacia tu pago inicial o costos de cierre.",
  "earnest-who-pays": "El comprador deposita (ya pagado durante la etapa de oferta)",
  "earnest-when": "Se deposita cuando se hace la oferta; se aplica al cierre",
  "earnest-why": "Esto muestra al vendedor que eres un comprador serio. Si la venta se cae por razones dentro de tu control, el vendedor puede quedarse con este dinero.",
  "earnest-if-deal-falls": "Si el trato se cae por razones válidas (la inspección del hogar falló, la valuación fue demasiado baja, el financiamiento se cayó), recuperas este dinero. Si es tu culpa, el vendedor se lo queda.",
  "earnest-amount": "Monto del Depósito de Buena Fe",
  "earnest-amount-detail": "Depósito ya hecho hacia el pago inicial",

  "payout-section": "Pagos de Préstamos Existentes",
  "payout-title": "Pago de Préstamo Existente",
  "payout-what-is": "Si el vendedor tiene una hipoteca existente u otro gravamen sobre la propiedad, esa deuda debe pagarse al cierre de las ganancias de la venta. Esto se llama un pago.",
  "payout-who-pays": "Las ganancias del vendedor se utilizan para pagar la deuda existente",
  "payout-when": "Se paga al cierre de las ganancias del vendedor",
  "payout-why": "La compañía de título requiere que todos los gravámenes se liquiden para que recibas propiedad clara de la propiedad",
  "payout-principal": "Principal del Pago",
  "payout-principal-detail": "Saldo restante en la hipoteca existente del vendedor",
  "payout-interest": "Interés del Pago (Diario)",
  "payout-interest-detail": "Interés acumulado desde el último pago hasta la fecha de cierre",

  "prorations-section": "Ajustes Diarios",
  "prorations-title": "Ajustes Diarios (Prorratas)",
  "prorations-what-is": "Cuando compras una propiedad, ciertos costos como impuestos sobre la propiedad, seguro y cuotas de HOA se dividen entre el comprador y el vendedor según el número de días que cada uno fue propietario de la propiedad durante el período de facturación actual. Estos ajustes se llaman prorratas. Esto asegura que cada parte pague solo por los días que fue propietario de la propiedad.",
  "prorations-who-pays": "Se divide entre el comprador y el vendedor según la fecha de cierre",
  "prorations-when": "Se ajusta al cierre",
  "prorations-why": "Esto asegura una división justa de gastos. El comprador no debería pagar un mes completo de impuestos por un día de propiedad, y el vendedor no debería dejar dinero sobre la mesa por los días que fue propietario.",
  "prorations-taxes": "Prorrata de Impuesto sobre la Propiedad",
  "prorations-taxes-detail": "Tu porción de impuestos sobre la propiedad según los días de propiedad",
  "prorations-insurance": "Prorrata de Seguro",
  "prorations-insurance-detail": "Tu porción del seguro de propietario según la fecha de cierre",
  "prorations-hoa": "Prorrata de Cuota de HOA",
  "prorations-hoa-detail": "Tu porción de cuotas de asociación de propietarios",
  "prorations-utilities": "Prorrata de Utilidades",
  "prorations-utilities-detail": "Tu porción de utilidades según el período de propiedad",

  "hoa-section": "Asociación de Propietarios",
  "hoa-title": "Asociación de Propietarios (HOA)",
  "hoa-what-is": "Una HOA es una organización de propietarios en una comunidad que establece reglas, mantiene áreas comunes y recolecta tarifas de todos los residentes. Si la propiedad es parte de una comunidad HOA, tendrás que pagar estas cuotas mensuales.",
  "hoa-who-pays": "Cada propietario paga mensualmente",
  "hoa-when": "Pagos mensuales continuos después del cierre",
  "hoa-why": "Las cuotas de HOA mantienen áreas comunes, proporcionan servicios comunitarios y mantienen los valores de las propiedades en la comunidad",
  "hoa-transfer": "Tarifa de Transferencia de HOA",
  "hoa-transfer-detail": "Tarifa única para transferir tu hogar a los registros de HOA",
  "hoa-status": "Informe de Estado de HOA",
  "hoa-status-detail": "Información sobre la HOA, reglas, reservas y estado financiero",

  "settlement-section": "Equilibrio de Liquidación",
  "settlement-balance-title": "Tabla de Equilibrio de Liquidación",
  "settlement-summary": "Esta tabla muestra cómo las cifras de liquidación se equilibran entre el comprador y el vendedor después de todos los costos, créditos y ajustes.",
  "settlement-buyer-side": "Lado del Comprador",
  "settlement-seller-side": "Lado del Vendedor",
  "settlement-buyer-debit": "Monto Adeudado por el Comprador",
  "settlement-buyer-credit": "Monto Pagado por el Comprador",
  "settlement-seller-debit": "Monto Adeudado por el Vendedor",
  "settlement-seller-credit": "Monto Recibido por el Vendedor",

  "funding-section": "Financiamiento del Prestamista",
  "funding-title": "Información de Financiamiento del Prestamista",
  "funding-loan-amount": "Monto del Préstamo Siendo Financiado",
  "funding-due-date": "Fondos Adeudados del Prestamista",
  "funding-wire-info": "Instrucciones de Transferencia Electrónica",

  "ui-expand-all": "Expandir Todo",
  "ui-collapse-all": "Contraer Todo",
  "ui-print": "Imprimir Divulgación",
  "ui-download": "Descargar PDF",
  "ui-language": "Idioma",
  "ui-english": "English",
  "ui-spanish": "Español",
  "ui-loading": "Cargando información de cierre...",
  "ui-error-generic": "Algo salió mal. Por favor intenta de nuevo.",
  "ui-error-loading": "No pudimos cargar tu divulgación de cierre. Podría ser temporal. Por favor intenta de nuevo.",
  "ui-error-missing-order": "No se encontró la orden. Por favor regresa y selecciona una orden válida.",
  "ui-error-empty-charges": "No se encontraron cargos para esta orden.",
  "ui-error-server": "El servidor no está disponible temporalmente. Por favor regresa en unos momentos.",
  "ui-error-permission": "No tienes permiso para ver esta divulgación de cierre.",
  "ui-retry": "Intenta de Nuevo",
  "ui-retry-message": "¿Tienes problemas? Intenta actualizar la página o contacta al soporte si el problema continúa.",
  "ui-loading-message": "Preparando tu información de divulgación de cierre...",
  "ui-empty-state": "Tu divulgación de cierre aparecerá aquí una vez que tengamos toda la información necesaria.",
  "ui-close": "Cerrar",
  "ui-back": "Atrás",
  "ui-next": "Siguiente",
  "ui-label-what": "¿Qué es esto?",
  "ui-label-who-pays": "¿Quién paga esto?",
  "ui-label-when": "¿Cuándo se paga esto?",
  "ui-label-why": "¿Por qué este cargo?",
  "ui-not-applicable": "No aplica",

  "summary-header": "Resumen de Cierre",
  "summary-total-due-buyer": "Total Adeudado por el Comprador",
  "summary-total-due-seller": "Total Adeudado por el Vendedor",
  "summary-loan-amount": "Monto del Préstamo",
  "summary-down-payment": "Pago Inicial",

  "legal-disclaimer": "Información Importante",
  "legal-disclaimer-text": "Esta Divulgación de Cierre proporciona una lista detallada de todos los cargos que se recopilarán al cierre. Si tienes preguntas sobre cualquier cargo, por favor contacta al agente de cierre o tu profesional de bienes raíces. Algunos montos pueden ser estimaciones y sujetos a ajuste final al cierre.",
  "legal-earnest-note": "Tu depósito de buena fe ya ha sido recolectado y será acreditado hacia tu pago inicial y costos de cierre al cierre.",
  "legal-inspection-notice": "Si la inspección del hogar reveló defectos, el informe de inspección puede haber sido utilizado para negociar créditos o reparaciones",

  "total-due": "Total Adeudado",
  "total-received": "Total Recibido",
  "amount": "Monto",
  "description": "Descripción",
  "date": "Fecha",
  "paid-by": "Pagado Por",
  "paid-to": "Pagado a",
  
   "property-coordinates": "Coordenadas",
   "no-properties-available": "No hay propiedades disponibles",

   "participants-title": "Participantes",
   "participants-buyers": "Compradores",
   "participants-sellers": "Vendedores",
   "participants-lenders": "Prestamistas",
   "participants-empty": "Sin participantes",
   
    "ui-error-generic": "Ocurrió un error",
    "ui-retry-message": "Hubo un problema al cargar la divulgación de cierre. Por favor, intenta de nuevo.",
    "ui-retry": "Reintentar",
    "ui-back": "Volver",
    "ui-support-contact": "Si el problema persiste, por favor contacta a nuestro equipo de soporte.",

    "cost-breakdown-title": "Desglose de Costos",
    "details-tab": "Detalles",
    "cost-breakdown-stacked-bar-title": "Comparación Comprador vs Vendedor",
    "cost-breakdown-pie-buyer": "Tus Costos en Cierre",
    "cost-breakdown-pie-seller": "Tus Ganancias",

    "roles-buyer": "Comprador",
    "roles-seller": "Vendedor",

    "categories-earnest": "Dinero de Depósito de Buena Fe",
    "categories-commission": "Comisión de Bienes Raíces",
    "categories-title-charge": "Cargos de Título",
    "categories-escrow": "Fondos de Depósito en Garantía",
    "categories-taxes": "Impuestos y Honorarios",
    "categories-other": "Otros Cargos",

     "chart-amount": "Cantidad",
     "chart-total": "Total",
     "chart-percentage": "Porcentaje",
     "waiting-for-breakdown-data": "Esperando que la información de costos esté disponible"
}
